export default {
    label: 'Image',
    requirements: 'Image requirements: JPEG-, PNG- or GIF.',
    error: {
        size: 'The image should not exceed a size of 8MB.',
        mimetype: 'Please only use images in JPEG, PNG or GIF format.',
        maxSizeExceeded: 'The image should not exceed a size of {maxSize}.'
    }
}
